import { currentLocale } from '../i18n'

/**
 * Returns the Monday (week start) for a given date.
 */
export function getMonday(d) {
  const date = new Date(d)
  const day = date.getDay() // 0=Sun, 1=Mon, ...
  const diff = (day === 0 ? -6 : 1 - day)
  date.setDate(date.getDate() + diff)
  date.setHours(0, 0, 0, 0)
  return date
}

/**
 * Format a date as YYYY-MM-DD (ISO local date, no timezone shift).
 */
export function toISODate(d) {
  const date = new Date(d)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${dd}`
}

/**
 * Format a date as "Apr 7, 2025" for display.
 */
export function formatDate(d) {
  return new Date(d + 'T00:00:00').toLocaleDateString(currentLocale(), {
    month: 'short', day: 'numeric', year: 'numeric',
  })
}

/**
 * Format a work-week range: "Apr 7 – Apr 11, 2025" (Mon–Fri)
 */
export function formatWeekRange(mondayStr) {
  const monday = new Date(mondayStr + 'T00:00:00')
  const friday = new Date(monday)
  friday.setDate(monday.getDate() + 4)
  const loc = currentLocale()
  const opts = { month: 'short', day: 'numeric' }
  return `${monday.toLocaleDateString(loc, opts)} – ${friday.toLocaleDateString(loc, { ...opts, year: 'numeric' })}`
}

/**
 * Add N weeks to a Monday string, return new YYYY-MM-DD.
 */
export function addWeeks(mondayStr, n) {
  const d = new Date(mondayStr + 'T00:00:00')
  d.setDate(d.getDate() + n * 7)
  return toISODate(d)
}

/**
 * Returns current week's Monday as YYYY-MM-DD.
 */
export function currentWeekMonday() {
  return toISODate(getMonday(new Date()))
}
